import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Spinner, Container } from 'react-bootstrap';

const RedirectReinscription = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    useEffect(() => {
        // Récupérer l'email depuis les paramètres de l'URL
        const email = searchParams.get('email');
        
        if (email) {
            // Rediriger vers la page de réinscription avec l'email
            navigate(`/reinscription?email=${email}`);
        } else {
            // Si pas d'email, rediriger simplement vers réinscription
            navigate('/reinscription');
        }
    }, [navigate, searchParams]);

    return (
        <Container className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
            <div className="text-center">
                <Spinner animation="border" role="status" variant="primary">
                    <span className="visually-hidden">Redirection...</span>
                </Spinner>
                <p className="mt-3">Redirection en cours...</p>
            </div>
        </Container>
    );
};

export default RedirectReinscription;
